<script lang="ts">
  import { AppState } from '../../etc/stores';

  const { primary600 } = $AppState.theme.colors;
</script>

<svg
  width="375"
  height="113"
  viewBox="0 0 375 113"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    opacity="0.8"
    d="M-85 14.2138C-85 6.36375 -78.6362 0 -70.7862 0H446.597C454.448 0 460.811 6.36375 460.811 14.2138V113L212.662 60.6799C196.337 57.2379 179.474 57.2379 163.149 60.6799L-85 113V14.2138Z"
    fill={primary600}
  />
</svg>
